// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addBtn[data-v-0d5f473d]{background:#2468f2;border-color:#2468f2;padding:0 20px}.addBtn[data-v-0d5f473d]:hover{background:rgba(36,105,242,.8392156862745098);border-color:rgba(36,105,242,.8392156862745098)}", ""]);
// Exports
module.exports = exports;
